import React from 'react';
import { VisuallyHidden } from 'reakit';
import { Box } from '@mos-cat/ds';
import { Dayjs } from 'dayjs';

import { getDay } from '../../../../../../../helpers/date';
import styles from './styles';

type Props = {
  date: Dayjs;
  isSelectedStart: boolean;
  isSelectedEnd: boolean;
  isInInterval: boolean;
};

export default function Day({ date, isSelectedStart, isSelectedEnd, isInInterval }: Props) {
  const day = getDay(date);
  const isSelected = isSelectedStart || isSelectedEnd;
  const isBaseDay = !isSelected && !isInInterval;
  return (
    <Box as="td" {...styles.dayWrapper}>
      <Box styles={styles.dayStyles({ isSelected, isInInterval })}>
        {day}
        {isSelectedStart && <VisuallyHidden>, начало отключения</VisuallyHidden>}
        {isSelectedEnd && <VisuallyHidden>, конец отключения</VisuallyHidden>}
        {isInInterval && <VisuallyHidden>, отключение</VisuallyHidden>}
        {isBaseDay && <VisuallyHidden>, нет отключения</VisuallyHidden>}
      </Box>
    </Box>
  );
}
